import {Controller} from "@hotwired/stimulus";

export const name = "lib--active_link";

export default class extends Controller<HTMLAnchorElement> {

    private readonly handleRouteChange = () => this.updateState();

    connect() {
        this.updateState();
        window.addEventListener("popstate", this.handleRouteChange);
        document.addEventListener("turbo:load", this.handleRouteChange);
        document.addEventListener("turbo:render", this.handleRouteChange);
    }

    disconnect() {
        window.removeEventListener("popstate", this.handleRouteChange);
        document.removeEventListener("turbo:load", this.handleRouteChange);
        document.removeEventListener("turbo:render", this.handleRouteChange);
    }

    activeClassesValueChanged() {
        this.updateState();
    }

    private updateState() {
        const href = this.element.getAttribute("href");
        if (!href) {
            return;
        }

        const targetUrl = new URL(href, window.location.origin);
        const targetPath = this.normalizePath(targetUrl.pathname);
        const currentPath = this.normalizePath(window.location.pathname);

        const isActive = targetPath === "/"
            ? currentPath === "/"
            : currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);

        if (isActive) {
            this.element.setAttribute("aria-current", "page");
        } else {
            this.element.removeAttribute("aria-current");
        }
    }


    private normalizePath(pathname: string): string {
        if (!pathname) {
            return "/";
        }

        const trimmed = pathname.replace(/\/+$/, "");
        return trimmed === "" ? "/" : trimmed;
    }
}
